module.exports = __webpack_public_path__ + "img/данные техн.4b0486cd.svg";